import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  page: css`
    display: flex;
    flex-flow: column nowrap;
    min-height: 100vh;
  `,
  container: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  header: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: ${colors.lightPrussian};
    height: 413px;
    margin-bottom: 48px;
    width: 100%;
  `,
  logo: css`
    margin-top: 24px;
    margin-bottom: 65px;
  `,
  description: css`
    margin-top: 24px;
    margin-bottom: 56px;
    padding: 0px 16px;
    text-align: center;
  `,
  footer: css`
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    width: 100%;
    padding: 0px 16px 0px 16px;
    gap: 12px;
  `,
};

export default styles;
